module.exports = __webpack_public_path__ + "0f1221ea062ca9dc4a1563875abebada.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/key_art-768.jpg
// module id = 442
// module chunks = 0